//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        introSprite: {
            type: String,
            default: '/images/game/extrapoints/robi.png'
        },
        introText: {
            type: String,
            default: ''
        },
        questions: {
            required: true,
            type: Array
        },
        bgPath: {
            type: String,
            default: ''
        },
        bgQuestionsPath: {
            type: String,
            default: ''
        }
    },

    data () {
        return {
            showNext: false,
            items: this.questions,
            index: 0,
            questionIndex: 0,
            correctAnswers: 0,
            estimationNumCorrect: -1,
            showCorrectBubble: false,
            showIncorrectBubble: false,
            showNextArrow: false,
        };
    },

    computed: {
        hasResult () {
            return this.$store.getters.hasUserResult(this.$route.meta.week, this.$route.meta.day, this.$route.meta.game);
        },
        correctActiveAnswerOption () {
            return this.items[this.questionIndex].answers.find(answer => answer.correct).option;
        },
        result () {
            return {
                stars: this.estimationNumCorrect === this.correctAnswers ? this.correctAnswers + 1 : this.correctAnswers,
                correct: this.correctAnswers,
                wrong: this.questions.length - this.correctAnswers,
                selfassessment: this.estimationNumCorrect - this.correctAnswers
            };
        },
        endText () {
            if (this.estimationNumCorrect === 0 && this.correctAnswers === 0) {
                return this.$lang.get('partials.extra.yourself', {br: '\n'});
            } else if (this.estimationNumCorrect < this.correctAnswers) {
                return `${this.$lang.get('partials.extra.underestimate', {br: '\n'})} ${this.estimationNumCorrect === 1 ? this.$lang.get('partials.extra.one', {br: '\n'}) : this.$lang.get('partials.extra.several', {br: '\n', estimationNumCorrect: this.estimationNumCorrect})} ${this.$lang.get('partials.extra.answers1', {br: '\n', correctAnswers: this.correctAnswers})}`;
            } else if (this.estimationNumCorrect > this.correctAnswers) {
                return `${this.$lang.get('partials.extra.close', {br: '\n'})} ${this.estimationNumCorrect === 1 ? this.$lang.get('partials.extra.one', {br: '\n'}) : this.$lang.get('partials.extra.several', {br: '\n', estimationNumCorrect: this.estimationNumCorrect})} ${this.$lang.get('partials.extra.answers2', {br: '\n', correctAnswers: this.correctAnswers})}`;
            }

            return this.$lang.get('partials.extra.great', {br: '\n'});
        }
    },

    created () {
        this.items.forEach(question => {
            question.answers.forEach((answer, index) => {
                answer.x = 450 + (index * 230);
                answer.y = 380;
                answer.alpha = 0;
            });
        });
    },

    methods: {
        answerQuestion (question, answer) {
            if (question.answers.every(answer => answer.alpha !== 1)) {
                answer.alpha = 1;

                if (answer.correct) {
                    this.showCorrectBubble = true;
                    this.correctAnswers++;
                } else {
                    this.showIncorrectBubble = true;
                }

                if (this.questionIndex === this.items.length - 1) {
                    this.showNext = true;
                } else {
                    this.showNextArrow = true;
                }
            }
        },
        nextQuestion () {
            this.showCorrectBubble = false;
            this.showIncorrectBubble = false;
            this.showNextArrow = false;
            this.questionIndex++;
        },
        getAnswerX (index) {
            let numOptions = this.questions.length + 1;
            let width = 460 / this.questions.length;

            return 450 + (index % numOptions) * width;
        }
    }
};
